/*
 * ITG: apply a region tag filter to every collection page URL.
 *
 * Problem it solves: our smart collections (and some shared manual ones)
 * contain both canary and mainland products. Without a server-side filter
 * Shopify paginates the full set — mainland customers can land on empty
 * pages 1..N before their region's products appear. Our CSS hides the
 * wrong-region cards, but Shopify's pagination count and the "empty pages"
 * problem remain.
 *
 * Two behaviours, depending on the collection:
 *
 * A. Manual collections that we've explicitly split into a canary and
 *    a mainland twin (NOVEDADES, CARTÓN WEEK, Página de inicio):
 *    - the canary collection contains only canary products
 *    - the mainland-twin collection contains only mainland products
 *    - tag-filtering the canary one for a mainland visitor would return
 *      zero results, so instead we redirect the visitor URL to the
 *      mainland-twin collection handle
 *
 * B. Every other collection (smart or shared manual):
 *    - contains a mix of canary + mainland products
 *    - apply Shopify's classic tag-URL syntax to filter server-side:
 *        /collections/<h>  ->  /collections/<h>/region-mainland
 *                            or /collections/<h>/region-canary
 *
 * Runs synchronously in <head> so there's no visible flash of the
 * unfiltered page before the redirect.
 *
 * Skips redirect when:
 *   - path is not a /collections/... page
 *   - path is /collections/all (aggregate view)
 *   - path is /collections/<h>/products/<h> (PDP)
 *   - path has a non-region tag segment already (respects merchant-curated
 *     tag landing pages)
 */
(function () {
  try {
    var path = window.location.pathname;
    if (!path || path.indexOf('/collections/') !== 0) return;

    // Skip the aggregate "all products" collection.
    if (path === '/collections/all' || path === '/collections/all/') return;

    var afterCollections = path.replace(/^\/collections\//, '').replace(/\/$/, '');
    if (!afterCollections) return;

    // Parse: handle[/tag] — either one or two segments after /collections/.
    // Skip if there's a /products/... segment (PDP under a collection).
    var parts = afterCollections.split('/');
    if (parts.length > 2) return;
    if (parts[1] === 'products') return;

    var handle = parts[0];
    var existingTag = parts[1] || '';

    // Read region: prefer the <html data-itg-region>, fall back to
    // localStorage, then default to canarias (matches theme default).
    var region = null;
    try { region = document.documentElement && document.documentElement.dataset && document.documentElement.dataset.itgRegion; } catch (e) {}
    if (!region) {
      try { region = localStorage.getItem('itg_region'); } catch (e) {}
    }
    if (!region) region = 'canarias';

    // --- Duplicated manual collections ---
    // Canary handle -> Mainland twin handle. Both regions must resolve
    // to their own collection URL (no tag-filter, because each twin
    // contains only its own region's products).
    var MANUAL_TWIN_MAP = {
      'novedades':           'novedades-mainland',
      'carton-week':         'carton-week-mainland',
      'frontpage':           'pagina-de-inicio-mainland'
    };
    // Reverse lookup: mainland handle -> canary handle
    var MANUAL_TWIN_REVERSE = {};
    for (var k in MANUAL_TWIN_MAP) {
      if (MANUAL_TWIN_MAP.hasOwnProperty(k)) {
        MANUAL_TWIN_REVERSE[MANUAL_TWIN_MAP[k]] = k;
      }
    }

    // If we're on a duplicated manual collection, redirect between the twins
    // instead of tag-filtering the current one (which would show 0 results).
    var wantedHandle = null;
    if (region === 'mainland' && MANUAL_TWIN_MAP.hasOwnProperty(handle)) {
      wantedHandle = MANUAL_TWIN_MAP[handle];
    } else if (region === 'canarias' && MANUAL_TWIN_REVERSE.hasOwnProperty(handle)) {
      wantedHandle = MANUAL_TWIN_REVERSE[handle];
    }
    if (wantedHandle && wantedHandle !== handle) {
      var twinPath = '/collections/' + wantedHandle;
      // Preserve any existing sub-path (unlikely for these) and query/hash.
      var twinUrl = twinPath + window.location.search + window.location.hash;
      window.location.replace(twinUrl);
      return;
    }
    // If we're already on the right twin, no tag-filter needed either —
    // the collection already contains only that region's products.
    if (
      (region === 'mainland' && MANUAL_TWIN_REVERSE.hasOwnProperty(handle)) ||
      (region === 'canarias' && MANUAL_TWIN_MAP.hasOwnProperty(handle))
    ) {
      return;
    }

    // --- Every other collection: tag-filter by region ---
    var wantedTag = region === 'mainland' ? 'region-mainland' : 'region-canary';
    var otherRegionTag = region === 'mainland' ? 'region-canary' : 'region-mainland';

    // Path has a non-region tag segment (e.g. /new, /featured).
    // Leave it alone — respect merchant-curated tag URLs.
    if (existingTag && existingTag !== wantedTag && existingTag !== otherRegionTag) {
      return;
    }

    // Already at the correct region tag — no-op.
    if (existingTag === wantedTag) return;

    var newPath = '/collections/' + handle + '/' + wantedTag;
    var newUrl = newPath + window.location.search + window.location.hash;

    // Replace (not push) so the back button doesn't ping-pong.
    window.location.replace(newUrl);
  } catch (e) { /* fail silent — user sees unfiltered collection */ }
})();
